import { useQuery } from '@tanstack/react-query'

import { getStoreCustomDomainStatus } from '@flecto/api/saas'

type QueryPayload = {
  domain?: string
  enabled?: boolean
}

export function useQueryGetStoreCustomDomainStatus({ domain, enabled = true }: QueryPayload) {
  return useQuery({
    queryKey: ['QueryGetStoreCustomDomainStatus', domain],
    queryFn: async () => await getStoreCustomDomainStatus(domain ?? ''),
    enabled: typeof enabled === 'boolean' ? enabled : Boolean(domain),
  })
}
